import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

const ClickableStyledIcon = styled(FontAwesomeIcon)`cursor:pointer;`;

export const ClickableIcon = (props: FontAwesomeIconProps) => <ClickableStyledIcon {...props} />;